import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const ProductionSection = (props: Props): FormSection => {
  return {
    key: "productionSettings",
    type: "regular",
    title: RESX.Production.resxProduction,
    fields: [{
      key: "production_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <YesNoText value={props.instruction.productionEnabled} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.productionEnabled}
          onChange={(v) => onChange(v, true)}
        />,
        type: "confirmOrCancelButton",
        initialValue: props.instruction.productionEnabled,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, productionEnabled: value });
        }
      }
    }]
  }
}